export default function TernaryCards() {
  return (
    <div className="container binarycontainer">
      {/* <div className="fa-2x" onClick={()=>navigate("/setting")}><BsArrowLeftCircleFill/></div> */}
      <h1 className="fw-semibold mb-2 text-center">Cartes en ternaire</h1>
    </div>
  );
}
